import React from 'react'
import BaseComponent from './BaseComponent'

export default class extends BaseComponent {

  constructor(props) {
    super(props)
    this._bind('initMap', 'setupMap', 'getData', 'initData', 'handleResize')
  }

  componentDidMount() {
    this.initMap()
    document.querySelector(".page-holder").addEventListener('resize', this.handleResize.bind(this))
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  handleResize() {
    this.map.resize()
  }

  componentDidUpdate() {
    setTimeout(this.handleResize, 300)
  }

  initMap() {
    window.mapboxgl.accessToken='pk.eyJ1IjoiamFrdWJzdHIiLCJhIjoiY2pyNmVjejRrMDBpeTN5bzI3MW5rZTBhMSJ9.SR7f3Jobks1VXii8m9usqg'

    this.map = new window.mapboxgl.Map( {
        container: 'map', style: 'mapbox://styles/mapbox/dark-v9', center: [19.5752418, 52.0931064], zoom: 5
    })

    this.map.on('load', this.initData)
  }

  initData() {
    fetch(this.props.API+'/api/admin/data/heatmap', {
      method: "POST",
      headers: {
        "Authorization" : "Bearer " + sessionStorage["token"]
      },
      body:JSON.stringify({}),
    })
    .then(resp => resp.json())
    .then(resp => {
      this.setupMap(resp)
    });
  }

  getData() {
    fetch(this.props.API+'/api/admin/data/heatmap', {
      method: "POST",
      headers: {
        "Authorization" : "Bearer " + sessionStorage["token"]
      },
      body:JSON.stringify({}),
    })
    .then(resp => resp.json())
    .then(resp => {
      this.map.getSource('clients').setData(resp)
    });
  }

  setupMap(res) {
    this.map.addSource('clients', {
        "type": "geojson", "data": res
    })

    this.map.addLayer( {
        "id": "clients-heat", "type": "heatmap", "source": "clients", "maxzoom": 9, "paint": {
            "heatmap-weight": [ "interpolate", ["linear"], ["get", "mag"], 0, 0, 6, 1],
            "heatmap-intensity": [ "interpolate", ["linear"], ["zoom"], 0, 1, 9, 3],
            "heatmap-color": [ "interpolate", ["linear"], ["heatmap-density"], 0, "rgba(33,102,172,0)", 0.2, "rgb(103,169,207)", 0.4, "rgb(209,229,240)", 0.6, "rgb(253,219,199)", 0.8, "rgb(239,138,98)", 1, "rgb(178,24,43)"], 
            "heatmap-radius": [ "interpolate", ["linear"], ["zoom"], 0, 2, 9, 20], 
            "heatmap-opacity": [ "interpolate", ["linear"], ["zoom"], 7, 1, 9, 0],
        }
    }, 'waterway-label')

    this.map.addLayer( {
        "id": "clients-point", "type": "circle", "source": "clients", "minzoom": 7, "paint": {
            "circle-radius": [ "interpolate", ["linear"], ["zoom"], 7, [ "interpolate", ["linear"], ["get", "mag"], 1, 1, 6, 4], 16, [ "interpolate", ["linear"], ["get", "mag"], 1, 5, 6, 50]], 
            "circle-color": [ "interpolate", ["linear"], ["get", "mag"], 1, "rgba(33,102,172,0)", 2, "rgb(103,169,207)", 3, "rgb(209,229,240)", 4, "rgb(253,219,199)", 5, "rgb(239,138,98)", 6, "rgb(178,24,43)"], "circle-stroke-color": "white", "circle-stroke-width": 1, 
            "circle-opacity": [ "interpolate", ["linear"], ["zoom"], 7, 0, 8, 1]
        }
    }, 'waterway-label')

    this.timer = setInterval(this.getData, 10000)
  }

  render () {

    return (
      <section className="heatmap">
        <div id='map'></div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/HeatMap.js